<div aria-labelledby="profile-tab" class="tab-pane fade" id="day2" role="tabpanel">
    <FlashMessage></FlashMessage>
    <div class="container-fluid">
        <div class="error-list" v-if="ui.error.error_message">
            <ul class="error-msg">
                <li :key="x" v-for="(error,x) in ui.error.error_message">
                    <div :key="i" v-for="(err,i) in error">
                        <p> {{err}}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="content-block">
            <form>
                <div class="form-modified">
                    <div class="empty-data green">
                        <p>
                            You can add, edit, or delete the price, length (duration), age-specification, per pax or
                            quota, and seasons for the package.
                        </p>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label" for="staticEmail">Suitable
                            seasons</label>
                        <div class="col-sm-10">
                            <label class="readonly" for="staticEmail" v-if="!ui.status.canEdit"><span
                                    :key="index" v-for="(season, index) in item.priceDurationData.trek_seasons"
                                    v-if="item.priceDurationData.trek_seasons">{{season? season.name : '' }}<span
                                    v-if="index < item.priceDurationData.trek_seasons.length -1">, </span></span></label>

                            <!-- <label v-if="!ButtonStatus" for="staticEmail" class="readonly"
                            ><span v-for="(season, s) in priceData.Season" :key="s"><span v-if="season.seasons">{{season.seasons}}</span></span> </label> -->
                            <div class="multiselect-input" v-if="ui.status.canEdit">

                                <multiselect
                                        :class="'overflow-input'"
                                        :close-on-select="false"
                                        :hide-selected="true"
                                        :multiple="true"
                                        :options='getSeasons'
                                        :preserve-search="true"
                                        :show-labels="false"
                                        :taggable="false"
                                        :track-by="'id'"
                                        label="name"
                                        placeholder="Choose Suitable Seasons.."
                                        v-model="item.priceDurationData.trek_seasons"
                                ></multiselect>
                                <!-- <pre class="language-json"><code>{{ priceData.Season.seasons  }}</code></pre> -->
                            </div>
                            <!-- <multiselect v-if="ButtonStatus" v-model="priceData.Season" placeholder="Choose Suitable Seasons.." label="name" track-by="id" :options="getSeasons" :multiple="true" :taggable="true" ></multiselect> -->
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label" for="inputPassword">Min-Max
                            Age <span class="required">*</span></label>
                        <div class="col-sm-5">
                            <label class="readonly position-relative" for="staticEmail" v-if="!ui.status.canEdit">
                                {{item.priceDurationData.min_age}}
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">min age</span>
                                </div>
                            </label>
                            <input :class="{ 'error-input' : ui.error.errors['min_age'] }"
                                   @keypress="preventNonNumericalInput($event)" class="form-control"
                                   id="inputPassword" oninput="validity.valid||(value='');" placeholder="Minimum age"
                                   type="text" v-if="ui.status.canEdit"
                                   v-model="item.priceDurationData.min_age">
                            <validation-error :errors="ui.error.errors" :field="'min_age'" :isError="ui.error.has_error"
                                              v-if="ui.error.has_error"/>
                        </div>
                        <div class="col-sm-5">
                            <label class="readonly position-relative" for="staticEmail" v-if="!ui.status.canEdit">
                                {{item.priceDurationData.max_age}}
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">max age</span>
                                </div>
                            </label>
                            <input :class="{ 'error-input' : ui.error.errors['max_age'] }"
                                   @keypress="preventNonNumericalInput($event)" class="form-control"
                                   id="inputPassword" oninput="validity.valid||(value='');" placeholder="Maximum age"
                                   type="text" v-if="ui.status.canEdit"
                                   v-model="item.priceDurationData.max_age">
                            <validation-error :errors="errors" :field="'max_age'" :isError="ui.error.has_error"
                                              v-if="ui.error.has_error"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label" for="inputPassword">Min-Max
                            people <span class="required">*</span></label>
                        <div class="col-sm-5">
                            <label class="readonly position-relative" for="staticEmail" v-if="!ui.status.canEdit">
                                {{item.priceDurationData.min_people}}
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">min people</span>
                                </div>
                            </label>
                            <input :class="{ 'error-input' : ui.error.errors['min_people'] }"
                                   @keypress="preventNonNumericalInput($event)" class="form-control"
                                   id="inputPassword" oninput="validity.valid||(value='');" placeholder="Minimum"
                                   type="text" v-if="ui.status.canEdit"
                                   v-model="item.priceDurationData.min_people">
                            <validation-error :errors="ui.error.errors" :field="'min_people'"
                                              :isError="ui.error.has_error" v-if="ui.error.has_error"/>
                        </div>
                        <div class="col-sm-5">
                            <label class="readonly position-relative" for="staticEmail" v-if="!ui.status.canEdit">
                                {{item.priceDurationData.max_people}}
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">max people</span>
                                </div>
                            </label>
                            <input :class="{ 'error-input' : ui.error.errors['max_people'] }"
                                   @keypress="preventNonNumericalInput($event)" class="form-control"
                                   id="inputPassword" oninput="validity.valid||(value='');" placeholder="Maximum"
                                   type="text" v-if="ui.status.canEdit"
                                   v-model="item.priceDurationData.max_people">
                            <validation-error :errors="ui.error.errors" :field="'max_people'"
                                              :isError="ui.error.has_error" v-if="ui.error.has_error"/>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label" for="inputPassword">Duration</label>
                        <div class="col-sm-5">
                            <label class="readonly position-relative" for="staticEmail" v-if="!ui.status.canEdit">
                                {{item.priceDurationData.duration_nights}}
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">night</span>
                                </div>
                            </label>
                            <input @keypress="preventNonNumericalInput($event)" class="form-control" id="inputPassword"
                                   oninput="validity.valid||(value='');" placeholder="Nights" type="text"
                                   v-if="ui.status.canEdit" v-model="item.priceDurationData.duration_nights">
                        </div>
                        <div class="col-sm-5">
                            <label class="readonly position-relative" for="staticEmail" v-if="!ui.status.canEdit">{{item.priceDurationData.duration_days}}
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">day</span>
                                </div>
                            </label>
                            <input :class="{ 'error-input' : ui.error.errors['max_days'] }"
                                   @keypress="preventNonNumericalInput($event)" class="form-control"
                                   id="inputPassword" oninput="validity.valid||(value='');" placeholder="Days"
                                   type="text" v-if="ui.status.canEdit"
                                   v-model="item.priceDurationData.duration_days">
                            <validation-error :errors="ui.error.errors" :field="'max_days'"
                                              :isError="ui.error.has_error" v-if="ui.error.has_error"/>

                        </div>
                    </div>

                    <!-- <div class="form-group row">
                        <label for="inputPassword" class="col-sm-2 col-form-label">Price
                            basis <span class="required">*</span></label>
                        <div class="col-sm-10">
                            <label v-if="!ButtonStatus" for="staticEmail" class="readonly"><span v-if="priceData.PricingBasis">{{priceData.PricingBasis ? priceData.PricingBasis.name : ''}}</span></label>
                            <div class="multiselect-input" v-if="ButtonStatus">
                                <multiselect
                                :options='getPricingBasis'
                                v-model="priceData.PricingBasis"
                                label="name"
                                :track-by="'name'"
                                placeholder="Choose Pricing Basis.."
                                :class="{ 'error-input' : errors['pricing_basis_id'] }"
                                ></multiselect>
                                <validation-error v-if="isError" :isError="isError" :errors="errors" :field="'pricing_basis_id'" />
                             </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="inputPassword" class="col-sm-2 col-form-label">Price ($ USD)<span class="required">*</span>
                            </label>
                            <div class="col-sm-10">
                                    <label v-if="!ButtonStatus"for="staticEmail" class="readonly">{{priceData.Price}}</label>
                                    <input
                                        v-if="ButtonStatus"
                                        type="text" @keypress="preventNonNumericalInput($event)" oninput="validity.valid||(value='');"
                                        class="form-control"
                                        id="inputPassword"
                                        placeholder="eg. 1400"
                                        v-model="priceData.Price"
                                        :class="{ 'error-input' : errors['base_price'] }"
                                    />
                                    <validation-error v-if="isError" :isError="isError" :errors="errors" :field="'base_price'" />
                             </div>
                    </div> -->

                    <div class="content-block">
                        <div class="row">
                            <div class="col-md-10 offset-md-2">
                                <button @click.prevent="addPriceDuration" class="btn default-btn save-btn"
                                        type="submit"
                                        v-if="ui.status.canEdit">{{buttonName}}
                                    <spinner :loading="ui.status.postLoading.create" v-if="ui.status.postLoading.create"></spinner>
                                </button>
                                <button :disabled="ui.status.postLoading.create" @click.prevent="cancelPriceDuration" class="btn default-btn cancel"
                                        type="submit" v-if="ui.status.canEdit">Cancel
                                </button>
                                <button @click.prevent="editPriceDuration" class="btn default-btn" type="submit"
                                        v-if="!ui.status.canEdit">Edit
                                </button>
                            </div>
                        </div>

                    </div>

                </div>

            </form>
        </div>
    </div>
</div>
